import React from "react";
import { HiOutlineQuestionMarkCircle } from "react-icons/hi";

export default function HelpSupport() {
  return (
    <div className="container mx-auto mt-8 p-6 bg-white rounded-xl shadow-sm max-w-3xl">
      <div className="flex items-center gap-3 mb-6">
        <HiOutlineQuestionMarkCircle className="text-4xl text-blue-600" />
        <h2 className="text-2xl font-semibold text-gray-900">Help & Support</h2>
      </div>
      <p className="text-gray-600 mb-6">
        Get assistance with the Lead Management application. Below are common resources and contacts.
      </p>
      <section className="space-y-4">
        <div className="rounded-lg border border-gray-200 p-4">
          <h3 className="font-semibold text-gray-900 mb-2">Documentation</h3>
          <p className="text-sm text-gray-600">
            Refer to the user guide for creating leads, managing contacts, follow-ups, and mail configuration.
          </p>
        </div>
        <div className="rounded-lg border border-gray-200 p-4">
          <h3 className="font-semibold text-gray-900 mb-2">Contact Support</h3>
          <p className="text-sm text-gray-600">
            For technical issues or questions, contact your administrator or Zaptas Technologies support.
          </p>
        </div>
      </section>
    </div>
  );
}
